import { AbstractMapFeature } from "@planalogic/design-system";

export class RelatedPlotsFeature extends AbstractMapFeature { }
